import gsap, { Power2 } from "gsap";

class Waypoint {
    constructor(el) {
        this.el = el;
        this.el && this.init();
    }

    init() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            root: null,
            rootMargin: "0px 0px -5% 0px",
            threshold: 0.1,
        });
        this.observer && this.observer.observe(this.el);
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                // Staggered
                const staggerStack = this.el.querySelectorAll("[data-stagger]");
                const staggerEffect = this.el.dataset.waypoint;
                staggerStack.length > 0 ? this.stagger(staggerStack, staggerEffect) : this.fade();

                this.observer.unobserve(this.el);
            }
        });
    }

    fade() {
        let tl = gsap.timeline();

        tl.set(this.el, {
            autoAlpha: 1,
        });

        tl.fromTo(
            this.el,
            {
                autoAlpha: 0,
            },
            {
                autoAlpha: 1,
                ease: Power2.easeInOut,
                duration: 1,
                onComplete: () => {
                    tl.kill();
                    tl = null;
                },
            }
        );
    }

    stagger(stack, effect) {
        let tl = gsap.timeline();

        tl.set([this.el], {
            autoAlpha: 1,
        });

        const getMovement = () => {
            if (effect === "down") {
                return { y: "-30" };
            }
        };
        const movement = getMovement();

        tl.fromTo(
            stack,
            {
                autoAlpha: 0,
                y: 0,
                x: 0,
                ...movement,
            },
            {
                autoAlpha: 1,
                y: 0,
                x: 0,
                stagger: 0.1,
                ease: Power2.easeInOut,

                onComplete: () => {
                    tl.kill();
                    tl = null;
                },
            }
        );
    }
}

const waypoints = () => {
    const waypoints = document.querySelectorAll("[data-waypoint]");
    waypoints &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        waypoints.forEach(el => {
            new Waypoint(el);
        });
};

export default waypoints;
